<template>
  <div class="custom-line" ref="myChart"></div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'CustomLine',
  data() {
    return {}
  },
  props: {
    options: {
      type: Object
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.myChart)
    this.myChart.setOption(this.lineOptions)
    this.myChart.resize()
  },
  computed: {
    lineOptions() {
      return {
        title: {
          text: this.options.title,
          textStyle: {
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          right: 0,
          orient: 'vertical',
          data: this.options.legend
        },
        grid: {
          containLabel: true,
          show: true // 网格边框是否显示，上和右边框
        },
        xAxis: this.options.xAxis,
        yAxis: this.options.yAxis,
        series: this.options.series
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.myChart.setOption(this.lineOptions)
        this.myChart.resize()
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus" scoped>
.custom-line {
  width: 900px;
  height: 450px;
}
</style>
